/**
 * Compose a full ISO timestamp from a calendar day (YYYY-MM-DD produced by
 * <input type="date">) plus the current time-of-day. Mirrors how the mobile
 * app writes `expense_date`, so rows sort consistently across devices under
 * `ORDER BY expense_date DESC` (otherwise web-created rows land at midnight
 * and sink below mobile-created rows from the same day).
 */
export function composeExpenseTimestamp(
  dateYYYYMMDD: string,
  referenceTime: Date = new Date(),
): string {
  const [year, month, day] = dateYYYYMMDD.split('-').map(Number);
  const composed = new Date(
    year,
    month - 1,
    day,
    referenceTime.getHours(),
    referenceTime.getMinutes(),
    referenceTime.getSeconds(),
    referenceTime.getMilliseconds(),
  );
  return composed.toISOString();
}
